// Do not change the values!!!
export enum TaxonomyStatus {
  Empty = 0,
  New = 1,
  Warning = 2,
  Error = 3,
  SubmittingError = 4,
  Submitted = 5
}
